module.exports = __webpack_public_path__ + "static/media/avast-vince-tovarna.5d2ee8fe.jpg";